import script from "./SelectPackageOption.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectPackageOption.vue?vue&type=script&setup=true&lang=js"

import "./SelectPackageOption.vue?vue&type=style&index=0&id=0dfc8db6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dfc8db6"]])

export default __exports__